import React from 'react';

export const userContext = React.createContext();
export const tenantContext = React.createContext();
